export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-annotate-cf222b50d6a1e4b264bb0fa4bb5cba0d.svg";